import '../../scss/pages/match-gift.scss';

import {renderGlobalFilters} from '../vue/modules/global-filters'

function initialize() {
    renderGlobalFilters();
}

document.addEventListener('DOMContentLoaded', initialize);
